<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('moneybag.rechargeRecord')}}</div>
        </div>
		<!-- <div class="user_yw">
			<p>{{$t('moneybag.accountBalance')}}</p>
			<p>{{$t('utils.moneyMark')}}{{funds}}</p>
		</div> -->
		<!-- <div class="user_zrzc">
			<span @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</span>
			<span @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</span>
		</div> -->
        <div class="detail_box">
			<van-empty :description="$t('item.noData')" v-if="listShow" />
            <div class="item" v-for="item in data">
                <div class="flexs">
                    <div class="de_wrap">
                        <div class="price" :class="item.status =='1'?'del':''" v-html="item.status =='1'?'+'+$t('utils.moneyMark')+item.money : ''+$t('utils.moneyMark')+item.money"></div>
                        <div class="text">
                            {{ $t('idNum') }} : 
                        </div>
                        <div class="text">
                            {{ item.orderid }}
                        </div>
                    </div>
                    <div>
                        <div class="text tr color_yellow" v-if="item.status === 0">{{$t('PendingReview')}}</div>
                        <div class="text tr color_green" v-if="item.status === 1">{{$t('Completed')}}</div>
                        <div class="text tr color_red" v-if="item.status === 2">{{$t('Rejected')}}</div>
                        <div class="text tr color_blue" v-if="item.status === 3">{{$t('PendingSubmission')}}</div>
                        <div class="time" style="margin-top: 10px;">{{item.time}}</div>
                    </div>
                </div>
                <div>
                    <div class="time" v-if="item.status === 2 && item.remark != ''"><span class="color_red">{{$t('AlasanPenolakan')}} : {{item.remark}}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);

    export default {
        name: "rechargeRecord",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
            Fetch('/user/info').then((r) => {
                this.funds = r.data.money;
                this.userName = r.data.username;
			});
        },
        mounted() {
            Fetch('/user/recharge_list',{
                reason_id: 1
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.showError(r.data.length);
                this.data = r.data;
                // this.funds = r.data.money;
                // this.userName = r.data.username;
            })
        },
        methods: {
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/recharge_list').then(r=>{
                        this.data = r.data;
                        this.showError(r.data.length);
                    })
                }else{
                    Fetch('/user/recharge_list',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data;
                        this.showError(r.data.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        height: 45px;
        background: #fff;
        position: fixed;
    }
	.user_yw{
		text-align: center;
		width: 96%;
		position: absolute;
		top: 78px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 20px 0;
		p:nth-child(1){
			font-size: 16px;
			color: #646566;
			margin-bottom: 20px;
		}
		p:nth-child(2){
			font-size: 20px;
			font-weight: bold;
		}
	}
	.user_zrzc{
		text-align: center;
		width: 96%;
        max-width: 720px;
		position: absolute;
		top: 173px;
		background: #FFFFFF;
		left: 50%;
        transform: translateX(-50%);
		border-radius: 0 0 5px 5px;
		padding: 15px 0;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			background: #000000;
			color: #FFFFFF;
			margin: 0px 20px;
			padding: 12px 10px;
			border-radius: 5px;
		}
	}

    .detail_box {
        width: 96%;
		margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 50px;
        .item {
            width: 100%;
            padding: 16px 2px;
            border-bottom: 1px solid #ECECEC;
            .flexs {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 14px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                }
            }

            .price {
                flex: 1;
                font-size: 18px;
                line-height: 28px;
                font-weight: bold;
                color: #333;
                white-space: nowrap;
                &.del {
                    color: #0cce36;
                }
            }
        }
    }
    
    .text {
        font-size: 14px;
        margin-bottom: 5px;
    }
    .tr {
        text-align: right;
    }
</style>
